import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { UserState, StorageCustomerInfo } from './types';

interface GetterType {
    IS_LOGIN: (state: UserState) => boolean;
    IS_CUSTOMER_INFO_SETTED: (state: UserState) => boolean;
}

export const getters: GetterTree<UserState, RootState> = {
    IS_LOGIN : (state: UserState) => () => {
        return state.token !== '' && state.expireTime > Date.now();
    },
    IS_CUSTOMER_INFO_SETTED: (state: UserState) => () => {
        return  state.customerInfo !== null
                && (state.customerInfo as StorageCustomerInfo).company_no !== undefined
                && (state.customerInfo as StorageCustomerInfo).customer_id !== undefined
                && (state.customerInfo as StorageCustomerInfo).customer_no !== undefined;
    }
};
